



























import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import NumberInputMixin from '@/components/ui/mixins/number-input-mixin';
import ValidatableInputMixin from '@/components/ui/mixins/validatable-input-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class CountInput extends mixins(NumberInputMixin, ValidatableInputMixin, PlanLimitsMixin) {
  @Prop() 
  label: string;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: '' })
  helpTooltip: string

  clickPlus() {
    if(!this.planLimitsEditable && this.showPlanLimitsIcon){return this.handleClickPlanLimits()}
    this.innerValue = +this.innerValue + 1;
  }

  inputClick() {
    if(!this.planLimitsEditable && this.showPlanLimitsIcon){return this.handleClickPlanLimits()}
  }

  clickMinus() {
    if(!this.planLimitsEditable && this.showPlanLimitsIcon){return this.handleClickPlanLimits()}
    this.innerValue = +this.innerValue - 1;
  }
}
